import type { AnniversaryKind } from "@couples/shared";

/** 予定・記念日カードの表示レーン(自分/相手/2人)。月グリッドと近日リストの両方で使う */
export function laneOf(
  assignedTo: string | null,
  selfId: string | undefined,
): "you" | "partner" | "both" {
  if (assignedTo === null) return "both";
  return assignedTo === selfId ? "you" : "partner";
}

/** 記念日カウントダウンの添え書き(「3周年」「3歳」) */
export function anniversarySuffix(kind: AnniversaryKind, count: number): string {
  return kind === "birthday" ? `${count}歳` : `${count}周年`;
}
